<script lang="ts">
	import { is_set_object } from '$lib/js/helpers'
	import type { FAQComponent } from '$lib/js/strapi/types'
	import '$lib/css/components/u-text.scss'
	import { PUBLIC_STRAPI_MEDIA } from '$env/static/public'

	
	interface Props {
		// The icon is not in Strapi, but we manually pass it in some parent components
		faq: FAQComponent & { icon?: string };
		color?: string;
		selected?: boolean;
	}

	let { faq, color = 'orange', selected = $bindable(false) }: Props = $props();

	let img = faq.image?.url ?? ''
</script>

{#if is_set_object(faq)}
	<div class="faq {color}" class:selected>
		<div class="faq__inner">
			<button class="faq__title lead-1" onclick={() => (selected = !selected)}>
				<div class="faq__title__inner">
					<div>
						{#if faq.icon}<span class="icon icon-{faq.icon}"></span>{/if}
						<span class="question">{faq.question}</span>
					</div>
					{#if img}
						<div class="faq__title__img">
							<img height="30" width="145" src="{PUBLIC_STRAPI_MEDIA}{img}" alt="Download logo" />
						</div>
					{/if}
				</div>
				<span class="opener"></span>
			</button>

			<div class="faq__answer u-text">
				<p>{@html faq.answer}</p>
			</div>
		</div>
	</div>
{/if}

<style lang="scss">
	.faq {
		background: var(--grey);
		transition: all linear 0.125s;
		margin-bottom: 10px;

		&.white {
			background: white;
			border-radius: 10px;
			box-shadow: 0px 0px 17px 5px rgba(0, 0, 0, 0.06);
			margin-bottom: 15px;
		}

		&.black {
			background: white;
			border: 1px solid #c5c5c5;
			border-radius: 5px;

			&.selected {
				.faq {
					&__title {
						color: black;
						border-color: #c5c5c5;
					}

					&__answer {
						border-top: 1px solid #c5c5c5;
					}
				}

				.opener {
					border-color: black;

					&::before,
					&::after {
						border-color: black;
						transform: none;
					}
				}
			}
		}

		button {
			width: 100%;
			text-align: left;
			color: #000;
			font-weight: 700;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin: 0;
			padding: 12px 12px 12px 15px;
			cursor: pointer;
			transition: all linear 0.125s;
			min-height: 48px;

			@media (min-width: 769px) {
				padding: 15px 12px 15px 20px;
				min-height: 58px;
			}
		}

		span.opener {
			position: relative;
			pointer-events: none;
			display: block;
			width: 18px;
			height: 18px;
			border: 2px solid #000;
			border-radius: 5px;
			transition: all linear 0.25s;

			&::before,
			&::after {
				content: '';
				position: absolute;
				border-bottom: 2px solid #000;
				width: 10px;
				left: 4px;
				top: calc(50% - 1px);
				transition: all linear 0.25s;
			}

			&::after {
				transform: rotate(90deg);
			}
		}

		&__title {
			&__inner {
				display: flex;
				justify-content: space-between;
				align-items: center;
				flex-grow: 1;
				padding-right: 20px;
			}

			&__img {
				display: flex;
				justify-content: end;
				img {
					width: auto;
					height: 30px;
					object-fit: contain;
				}
			}
			span {
				margin-right: 8px;

				&.icon-shipping {
					font-size: 15px;
				}
			}
		}

		&__answer {
			visibility: hidden;
			opacity: 0;
			padding: 0;
			border-top: 1px solid var(--main);
			margin: 0 20px !important;
			transition: all linear 0.125s;
			height: 0;
			pointer-events: none;
			color: black;

			a {
				display: inline-block;
				margin-bottom: 10px;
				font-size: 16px;
			}
		}

		&.selected {
			.faq {
				&__title {
					color: var(--main);
				}

				&__answer {
					visibility: visible;
					opacity: 1;
					position: static;
					pointer-events: all;
					height: auto;
					padding: 20px 0 15px;
				}
			}

			.opener {
				border-color: var(--main);

				&::before,
				&::after {
					border-color: var(--main);
					transform: none;
				}
			}
		}
	}
</style>
